<template>
    <entity-reader
        entity="ritual"
        :id="id"
        api-name="ritualCircles"
        edit-route-name="editRitualCircle"
        :use-sharing="false"
    >
        <template v-slot:[`reader`]="{ doc }">
            <label-value name="Name" :value="doc.name" />
            <label-value name="Size" :value="doc.sizeName" />
            <label-value name="Active" :value="doc.active" />
            <label-value name="Location" :value="doc.location" />
            <label-value name="Bounce Location" :value="doc.bounceLocation" />
            <label-value name="Description" :value="doc.description" />
            <label-value name="Notes" :value="doc.notes" />
            <label-value name="Is Hidden" :value="doc.isHidden" />
            <label-value name="Flavour" :value="doc.flavour" />
        </template>
    </entity-reader>
</template>
<script>
import EntityReader from '../../components/EntityRead'
import LabelValueRender from '../../components/LabelValueRender'
export default {
    name: 'RitualCircleReader',
    components: {
        'entity-reader': EntityReader,
        'label-value': LabelValueRender,
    },
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
    },
}
</script>
